import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';

import { environment } from './environments/environment';
import { AppComponent } from 'app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));